module.exports = __webpack_public_path__ + "img/service-welcome.58720f4c.png";